import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import history from "./Store/history";
import { store } from "./Store/store";
import { Router } from "react-router-dom";
import "antd/dist/antd.css";
import "./index.css";

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} basename="/">
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
